module.exports = __webpack_public_path__ + "img/history3.bec17f10.jpeg";